import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Flexbox } from '@piconetworks/pkg-box';
import Trigger from './Trigger.js';

var _excluded = ["children", "className", "disabled", "flexboxContainer", "onClick", "triggerComponent"];
var Container = function Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    flexboxContainer = _ref.flexboxContainer,
    onClick = _ref.onClick,
    triggerComponent = _ref.triggerComponent,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Flexbox.Container, _extends({
    className: cx(className)
  }, flexboxContainer, props), children, /*#__PURE__*/React.isValidElement(triggerComponent) && /*#__PURE__*/React.createElement(Trigger, {
    onClick: onClick,
    disabled: disabled
  }, triggerComponent));
};
Container.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Adding flexbox container props to here,
   */
  flexboxContainer: PropTypes.object,
  /**
   * Disables the onClick Actioon, preventing mouse events,
   */
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  triggerComponent: PropTypes.any.isRequired,
  /**
   * On click action for bottom of the list button
   */
  onClick: PropTypes.func
};
Container.defaultProps = {
  disabled: false
};

export { Container as default };
//# sourceMappingURL=Container.js.map
